/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Collapse,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FindInPageOutlined, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { ProjetosOffGridProvider } from "src/providers/ProjetosOffGridProvider";
import { acessouEditarEstruturas$, OFFGRID_ERROR_MESSAGES, oldEstruturas$, useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import theme from "src/theme/light";
import { Layout } from "../_layout"
import { TipoPropostaInput } from "./tipoProposta";
import { ValorServicoInput } from "./valorServico";
import { Fileira, FormProjetoOffGridType, ListagemItem, ProjetoCalcular, ResultadoCalculos } from "../../types";
import { validacaoValorServicoMinimo } from "../../utils/validarValorServicoMinimo";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { ResumoProjeto } from "./resumoProjeto";
import { ServicoInformationModal } from "../../containers/ServicoInformationModal";
import { formatarComponentesCalcular } from "../../utils/formatarComponentesCalcular";
import { elSemEstrutura, ModalEditarEstruturas } from "./modalEditarEstruturas";
import { calcularEstruturas } from "../utils/calcularEstruturas";
import { buscarEstruturasPorModulo } from "../utils/buscarEstruturasPorModulo";
import { showEstruturasRemovidasAlert } from "../../utils/showEstruturasRemovidasAlert";
import { JustificativaValorServico } from "../../containers/InputsSection/containers/InputJustificativaValorServico";
import { exibeJustificativaValorServico$, modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { calcularAcessorios } from "../utils/calcularAcessorios";
import { ORDEM_GRUPO_CATEGORIAS, POSICAO_MODULO, PROPOSTA_OPTIONS, VALOR_MULTIPLO_CABO } from "../../constants";
import { mostrarAvisoServicoRemovido } from "../../utils/mostrarAvisoServicoRemovido";
import { calcularPotenciaEquipamentosOffGrid } from "../../utils/calcularPotenciaEquipamentosOffGrid";
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants";
import { useObservable } from "src/framework/store/storeUtil";
import { SolucaoMobile } from "./SolucaoMobile";
import { notifierStore } from "src/framework/store/NotifierStore";
import { CategoriaComponente, ID_CABO, ID_STRING_BOX, TGrupoCategoria } from "src/components/componentes/types";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { categorias_componentes$ } from "src/store/global.store";
export const ACESSORIOS_MANTIDOS_EDICAO = [ID_CABO, ID_STRING_BOX];

const ProdutoCell = ({ children }: { children: ReactNode }) => {
  return (
    <TableCell align='left'>
      {children}
    </TableCell>
  )
}

const CodigoCell = ({ children }: { children: ReactNode }) => {
  return (
    <TableCell style={{ width: "126px" }} align='left'>
      {children}
    </TableCell>
  )
}

const QuantidadeCell = ({ children }: { children: ReactNode }) => {
  return (
    <TableCell style={{ width: "220px" }} align='center'>
      {children}
    </TableCell>
  )
}

const EmptyCell = ({ children }: { children?: ReactNode }) => {
  return (
    <TableCell style={{ width: "200px" }}  align='right'>
      {children}
    </TableCell>
  )
}

const DadosTecnicosCell = ({ componente }: { componente: { componente_id: number | null | undefined } }) => {
  return (
    <TableCell style={{ width: "200px" }} align='center'>
      <Box display={"flex"} alignItems="center" justifyContent={"center"}>
        <IconButton
          onClick={e => {
            e.stopPropagation();
            if (componente?.componente_id) {
              modalComponentesDetalhesData$.next(componente.componente_id)
            }
          }}
          size="large">
            <FindInPageOutlined htmlColor="black" />
        </IconButton>
      </Box>
    </TableCell>
  );
}

const useStyles = makeStyles({
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  restoreButton: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.getContrastText(theme.palette.warning.dark),
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    }
  },
  restoreButtonConfirm: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    }
  },
  tableHeaderRow: {
    height: 75,
    backgroundColor: "#0000000D",
    cursor: 'pointer'
  },
  collapseContainer: {
    marginBottom: 20,
  },
})

interface SolucaoProps {
  onClickNext: () => void
  onClickBack: () => void
}

let timerCalcular: NodeJS.Timeout

const projetosProvider = new ProjetosProvider();
const projetosOffGridProvider = new ProjetosOffGridProvider();

export const Solucao = ({ onClickBack, onClickNext }: SolucaoProps) => {
  const classes = useStyles();
  const permissoes = PermissionUtil.getPermissions();

  const [modalEditarEstruturasOpen, setModalEditarEstruturasOpen] = useState(false)
  const [collapseOpened, setCollapseOpened] = useState(true)
  const [calculando, setCalculando] = useState(false)
  
  const { tipo_bateria, equipamentos, recalcular: recalcularValores, old_componentes_edicao, old_estado_id, autonomia_banco_bateria, total_consumo_diario_w, tensao_saida, resultado_calculos, estrutura_selecionada, geracao_necessaria_kw, fileiras, modulo_selecionado, id: idProjeto, acessorios, estruturas_calculadas, solucao_calculada, clonar_projeto, distribuidor, revenda, segmento, estado, recebe_servico, valor_servico_pis_cofins, isEdit, valor_servico, valor_minimo_servico, modulos, geracao_necessaria_w, tipo_proposta, regioes, justificativa_valor_servico } = useProjetosOffGridStore(store => store.state.data)
  const projetosOffGridStoreValidationState = useProjetosOffGridStore(store => store.state.validations)
  const { changeValue: changeStoreValue, syncFileiras, addSolucaoCalculada } = useProjetosOffGridStore(store => store.actions)
  const oldEstruturas = useObservable(oldEstruturas$);
  const acessouEditarEstruturas = useObservable(acessouEditarEstruturas$);
  const categoriasComponentes = useObservable(categorias_componentes$);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const onChangeQuantidade = useCallback((componente_id: number,value: number, tipo_componente: "acessorios" | "estruturas") => {
    switch (tipo_componente) {
      case "acessorios":
        const newAcessorios = acessorios.map(item => {
          if (item.componente_id === componente_id) {
            return { ...item, quantidade: value }
          }
          return item;
        })
        changeStoreValue({ acessorios: newAcessorios })
        break;
      case "estruturas":
        const newEstruturas = estruturas_calculadas.map(item => {
          if (item.componente_id === componente_id) {
            return { ...item, quantidade: value }
          }
          return item;
        })
        changeStoreValue({ estruturas_calculadas: newEstruturas })
        break;
    }
  }, [acessorios, changeStoreValue, estruturas_calculadas])

  useEffect(()=>{
    if ((isEdit || clonar_projeto) && Number(valor_servico || 0) > 0 && !revenda?.segmentos_servico?.includes(segmento?.includes("on") ? "on" : "off")) {
      changeStoreValue({
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
        servico: null,
        justificativa_valor_servico: null,
        tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao')
      })
      
      mostrarAvisoServicoRemovido()
    }
  },[changeStoreValue, clonar_projeto, isEdit, revenda?.segmentos_servico, segmento, valor_servico])

  useEffect(()=>{
    if (recebe_servico === false || !revenda) {
      changeStoreValue({
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
        servico: null,
        justificativa_valor_servico: null,
        tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao')
      })
    }
  },[changeStoreValue, recebe_servico, revenda])

  const servicoObrigatorio = useMemo(()=>{
    return tipo_proposta?.value === 'gerador-com-instalacao'
  },[tipo_proposta?.value])

  const calcular = useCallback(async()=>{
    const getValorServico = () => {
      if (!recebe_servico) return 0;
      if (tipo_proposta?.value === 'gerador-sem-instalacao') return 0;
      return Number(valor_servico || 0)
    }

    const moduloSelecionado = modulo_selecionado || null;

    const componentes = [];

    if (moduloSelecionado) {
      componentes.push(...formatarComponentesCalcular([moduloSelecionado]));
    }

    if (solucao_calculada.baterias.length > 0) {
      componentes.push(...formatarComponentesCalcular(solucao_calculada.baterias));
    }

    if (solucao_calculada.controladores.length > 0) {
      componentes.push(...formatarComponentesCalcular(solucao_calculada.controladores));
    }

    if (solucao_calculada.inversores.length > 0) {
      componentes.push(...formatarComponentesCalcular(solucao_calculada.inversores));
    }

    if (estruturas_calculadas.length > 0) {
      componentes.push(...formatarComponentesCalcular(estruturas_calculadas))
    }

    if (acessorios.length > 0) {
      componentes.push(...formatarComponentesCalcular(acessorios))
    }

    const componentesFiltrados = componentes.filter(c => c.quantidade > 0)

    const recalcular = projetosProvider.confereRecalcular(componentesFiltrados, {
      recalcular: recalcularValores,
      alterou_segmento: false,
      estado_id: estado?.id || '',
      old_estado_id,
      old_componentes_edicao,
    });

    const payload: ProjetoCalcular = {
      componentes: componentesFiltrados,
      estado_id: estado?.id || '',
      servicos: {
        valor_margem_produtos: 0,
        tipo: getValorServico() ? 'revenda' : null,
        valor: getValorServico(),
      },
      regioes: regioes || [],
      segmento: segmento,
      projeto_id: clonar_projeto ? undefined : (idProjeto || undefined),
      distribuidor_id: distribuidor?.id || undefined,
      revenda_id: revenda?.id || undefined,
      recalcular: recalcular,
    }

    const responseCalcular: IDataResponse<ResultadoCalculos> = await projetosProvider.calcular(payload, true)

    if (responseCalcular.statusCode !== STATUS_CODE.OK) {
      // Limpa valores calculados anteriormente, caso ocorra algum erro no cálculo.
      changeStoreValue({ valor_servico_pis_cofins: 0, resultado_calculos: null })
      return;
    }

    changeStoreValue({ valor_servico_pis_cofins: responseCalcular?.data?.servicos?.valor_com_pis_cofins || 0, resultado_calculos: responseCalcular.data })
  },[acessorios, changeStoreValue, clonar_projeto, distribuidor?.id, estado?.id, estruturas_calculadas, idProjeto, modulo_selecionado, old_componentes_edicao, old_estado_id, recalcularValores, recebe_servico, regioes, revenda?.id, segmento, solucao_calculada.baterias, solucao_calculada.controladores, solucao_calculada.inversores, tipo_proposta?.value, valor_servico])

  useEffect(()=>{
    clearTimeout(timerCalcular)
    setCalculando(true)
    timerCalcular = setTimeout(()=>{
      calcular().finally(() => setCalculando(false))
    }, 200)
  }, [calcular])

  const comparaEstruturas = (antiga: ListagemItem[], atual: ListagemItem[])=>{  
    if (antiga?.length !== atual?.length) return false;
      return antiga.every(itemAntigo => {
        const itemAtual = atual.find(a => a.componente_id === itemAntigo.componente_id);
        return itemAtual?.quantidade === itemAntigo?.quantidade;
      });
  }

  const temPermissaoCodigoComponente = useMemo(()=>{
    return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)
},[permissoes])

  const onChangeModulo = useCallback(async (moduloId: number )=>{
    const moduloSelecionado = modulos.find(item => item.componente_id === moduloId)
    const alterouModulo = moduloId !== modulo_selecionado?.componente_id;

    if (moduloSelecionado) {
      const qtdModulosResult = await projetosOffGridProvider.calcularQtdModulos({
        moduloId: moduloSelecionado.componente_id,
        potencia: geracao_necessaria_w || 0,
      })

      if (qtdModulosResult.statusCode !== STATUS_CODE.OK) {
        notifierStore.setNotifier({
            content: qtdModulosResult.message,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 4000,
            title: "Atenção"
        })

        notifierStore.setOpen(true)
        return;
      }

      const potenciaFotovoltaica = qtdModulosResult.data?.potencia_fotovoltaica || 0;
      let qtdModulos = qtdModulosResult.data?.quantidade || 0;
      let alterouQtdModulos = Number(modulo_selecionado?.quantidade || 0) !== qtdModulos;

      const savePayload: Partial<FormProjetoOffGridType> = {
        modulo_selecionado: {  ...moduloSelecionado, quantidade: qtdModulos },
        potencia_fotovoltaica: potenciaFotovoltaica,
      }

      let limparEstrutura = false;
      // let acessorios: ListagemItem[] = [];
      if (alterouModulo) {
        const potenciaModulosEmWatts = savePayload.modulo_selecionado ? (savePayload.modulo_selecionado.quantidade * savePayload.modulo_selecionado.potencia) : 0
        const potenciaModulosEmKiloWatts = potenciaModulosEmWatts ? DecimalUtil.toFixed(potenciaModulosEmWatts / 1000, 2) : 0
        const valorMinimoServicoResult = await projetosProvider.calcularValorMinimoServico(potenciaModulosEmKiloWatts, apiNoLoading)
        if (valorMinimoServicoResult.statusCode !== STATUS_CODE.OK) {
          notifierStore.setNotifier({
            content: valorMinimoServicoResult.message || "Erro ao calcular valor mínimo de serviço.",
            onClose: () => notifierStore.setOpen(false),
            timeOut: 4000,
            title: "Atenção"
          })

          notifierStore.setOpen(true)
          return;
        }
        
        Object.assign(savePayload, { valor_minimo_servico: valorMinimoServicoResult.data?.valor_minimo_servico || 0 })

        const solucaoCalculadaResponse = await projetosOffGridProvider.calcularSolucao({
          autonomia_bateria: Number(autonomia_banco_bateria || 0),
          regioes: regioes,
          quantidade_modulos: qtdModulos,
          potencia_fotovoltaica: potenciaFotovoltaica,
          consumo_total_diario: total_consumo_diario_w,
          tipo_bateria: tipo_bateria?.id || null,
          tensao_saida: tensao_saida?.id || '',
          potencia_equipamentos: calcularPotenciaEquipamentosOffGrid(equipamentos || [])
        })

        if (solucaoCalculadaResponse.statusCode !== STATUS_CODE.OK) {
          notifierStore.setNotifier({
            content: solucaoCalculadaResponse.message,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 4000,
            title: "Atenção"
          })

          notifierStore.setOpen(true)
          return;
        }

        if (solucaoCalculadaResponse.data) {
          addSolucaoCalculada(solucaoCalculadaResponse.data)
          
          if (solucaoCalculadaResponse.data.modulo?.alterouQuantidade && !!savePayload.modulo_selecionado) {
            const qtd = solucaoCalculadaResponse.data.modulo.quantidade || qtdModulos || 0;
            Object.assign(savePayload, { modulo_selecionado: {  ...savePayload.modulo_selecionado, quantidade: qtd } })
            qtdModulos = qtd;
            alterouQtdModulos = true;
          }
        }

        const acessoriosResponse = await calcularAcessorios({
          moduloId: moduloSelecionado?.componente_id || 0,
          quantidade_modulos: qtdModulos,
          regioes: regioes,
          controladores: solucaoCalculadaResponse.data?.controladores || [],
          inversores: solucaoCalculadaResponse.data?.inversores || [],
        })

        if (acessoriosResponse.statusCode !== STATUS_CODE.OK) {
          return;
        }

        const acessoriosOriginais = acessorios ?? [];
        const acessoriosCalculados = acessoriosResponse?.data ?? [];

        const novosAcessorios = acessoriosCalculados.map((itemCalculado) => {
          if (ACESSORIOS_MANTIDOS_EDICAO.includes(itemCalculado.categoria_componentes_id)) {
            const itemOriginal = acessoriosOriginais.find(
              (item) => item.componente_id === itemCalculado.componente_id
            );

            if (itemOriginal) {
              return itemOriginal;
            }
          }
          return itemCalculado;
        });

        // acessorios = acessoriosResponse.data;

        const estruturasResponse = await buscarEstruturasPorModulo({
          moduloId: moduloSelecionado.componente_id,
          potencia: geracao_necessaria_kw,
          regioesId: regioes,
        })
        if(estruturasResponse?.ativos?.length){
            if(!estruturasResponse.ativos.find(item=> item.estruturas_grupo_id === estrutura_selecionada?.estruturas_grupo_id)){
              const fileiraReset = [
                {
                  fileiras: 1,
                  quantidade_modulos: qtdModulos,
                  tipo_estrutura: { image: elSemEstrutura?.url_imagem, text: elSemEstrutura?.nome, value: elSemEstrutura?.id, estruturas_grupo_id: elSemEstrutura?.estruturas_grupo_id },
                  posicao_modulo: POSICAO_MODULO.find(item => item.value === 'retrato') || null,
                }
              ];
              Object.assign(savePayload, { estrutura_selecionada: elSemEstrutura});  
              Object.assign(savePayload, { fileiras: fileiraReset })
              //payload.estrutura_selecionada = null;
            }
        }
        Object.assign(savePayload, { todas_estruturas: estruturasResponse.ativos, estruturas: estruturasResponse.retrato, acessorios: novosAcessorios })

        if (fileiras.length === 1) {
          if (!!estrutura_selecionada?.id && !estruturasResponse.ativos.find(item => item.id === estrutura_selecionada?.id && item.estruturas_grupo_id === estrutura_selecionada?.estruturas_grupo_id)) {
            Object.assign(savePayload, { estrutura_selecionada: elSemEstrutura })
            showEstruturasRemovidasAlert()
            limparEstrutura = true
          }
        } else if (fileiras.length > 1) {
          const fileirasComEstrutura = fileiras.filter(item => item.tipo_estrutura?.value && Number(item.tipo_estrutura.value) > 0);
          if (fileirasComEstrutura.length > 0 && !fileirasComEstrutura.every(item => estruturasResponse.ativos.find(estrutura => estrutura.id === item.tipo_estrutura?.value))) {
            Object.assign(savePayload, { estrutura_selecionada: elSemEstrutura })
            showEstruturasRemovidasAlert()
            limparEstrutura = true
          }
        }

        if (!limparEstrutura) {
          const fileirasComEstrutura = fileiras.filter(item => item.tipo_estrutura?.value && Number(item.tipo_estrutura.value) > 0);
          //novas fileiras
          if(fileirasComEstrutura?.length){
            const ativos = estruturasResponse.ativos || [];
            const tipoEstruturaAtualAtiva = ativos?.find(e=>e.id === estrutura_selecionada?.id);
            const grupoPadraoRetrato = tipoEstruturaAtualAtiva?.grupos.find(g=>g.posicao === "retrato");
            let itemImageUrl = grupoPadraoRetrato?.url_imagem || elSemEstrutura.url_imagem;

            if (estrutura_selecionada?.id === 0) {
              itemImageUrl = elSemEstrutura.url_imagem;
            }
            //identifica grupo padrao
            const fileiraReset = [
            {
              fileiras: 1,
              quantidade_modulos: qtdModulos,
              tipo_estrutura: { 
                image: itemImageUrl, 
                text: grupoPadraoRetrato ? estrutura_selecionada?.nome : elSemEstrutura.nome, 
                value: grupoPadraoRetrato ? estrutura_selecionada?.id : elSemEstrutura.id, 
                estruturas_grupo_id: grupoPadraoRetrato ? grupoPadraoRetrato?.id : elSemEstrutura?.estruturas_grupo_id, 
              },
              posicao_modulo: POSICAO_MODULO.find(item => item.value === 'retrato') || null,
            }];
            Object.assign(savePayload, { fileiras: fileiraReset })
            const estruturaResult = await calcularEstruturas({
              moduloId: moduloSelecionado?.componente_id || 0,
              controladores: solucaoCalculadaResponse.data?.controladores || [],
              fileiras: fileiraReset as Fileira[],
              inversor: '',
              inversores: solucaoCalculadaResponse.data?.inversores || [],
              potencia: geracao_necessaria_kw,
              regioes: regioes,
            })
            oldEstruturas$.next(estruturaResult);
            if (!comparaEstruturas(oldEstruturas, estruturaResult)){
              Object.assign(savePayload, { estruturas_calculadas: estruturaResult })
            }else {
              Object.assign(savePayload, { estruturas_calculadas: estruturas_calculadas })
            }
          }else{
            Object.assign(savePayload, { estruturas_calculadas: [] })
            oldEstruturas$.next([]);
          }
          if(acessouEditarEstruturas){
              notifierStore.setNotifier({
              content: "Importante: Quantidade de estruturas recalculada considerando o cenário padrão de uma (1) fileira em posição retrato. Revise a disposição dos módulos e fileiras, se necessário.",
              onClose: () => notifierStore.setOpen(false),
              timeOut: 4000,
              title: "Aviso!"
            })
          notifierStore.setOpen(true)
          }
        } else {
          Object.assign(savePayload, { estruturas_calculadas: [] })
          oldEstruturas$.next([]);
        }
      }
      acessouEditarEstruturas$.next(false)
      changeStoreValue(savePayload)
      syncFileiras(undefined, limparEstrutura ? elSemEstrutura : undefined, alterouQtdModulos)
    }
  }, [addSolucaoCalculada, autonomia_banco_bateria, tipo_bateria, changeStoreValue, equipamentos, estrutura_selecionada?.id, fileiras, geracao_necessaria_kw, geracao_necessaria_w, modulo_selecionado?.componente_id, modulo_selecionado?.quantidade, modulos, regioes, syncFileiras, tensao_saida?.id, total_consumo_diario_w, acessorios, oldEstruturas, estruturas_calculadas])

  const mostrarCampoValorServico = useMemo(()=>{
    return !!(servicoObrigatorio && recebe_servico) 
  },[servicoObrigatorio, recebe_servico])

  const exibirJustificativaValorServico = useMemo(() => {
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
    if (!mostrarCampoValorServico) return false;
    
    if (!valor_servico) return false;
    if (!valor_minimo_servico) return false;

    const valorServicoProjeto = Number(valor_servico || 0)
    return valorServicoProjeto < Number(valor_minimo_servico || 0);
  },[mostrarCampoValorServico, permissoes, valor_minimo_servico, valor_servico])

  const checkError = useCallback((categoriaId: number, qtd: number): boolean => {
    if (categoriaId !== ID_CABO) {
      return false;
    }
    if (qtd === 0) {
      return false;
    }
    if (qtd % 25 === 0) {
      return false;
    }
    return true
  },[])
  
  useEffect(()=>{
    exibeJustificativaValorServico$.next(exibirJustificativaValorServico)
  },[exibirJustificativaValorServico])

  const nextButtonDisabledStatus = useMemo((): { status: boolean, tooltip: string } => {
    const validations: { tooltip: string, validationFn: () => boolean }[] = [
      {
        tooltip: projetosOffGridStoreValidationState.fileiras.helper || OFFGRID_ERROR_MESSAGES.FILEIRAS_INVALIDAS,
        validationFn: () => {
          const estruturaFaltante = fileiras.some(item => !item.tipo_estrutura);
          const modulosFileiras = (fileiras || []).reduce((acc, curr) => {
            return acc + (Number(curr.quantidade_modulos || 0) * Number(curr.fileiras || 0))
          }, 0)
          const qtdModulosCalculados = Number(modulo_selecionado?.quantidade || 0);

          return !projetosOffGridStoreValidationState.fileiras.status || (modulosFileiras !== qtdModulosCalculados) || estruturaFaltante || false;
        }
      },
      {
        tooltip: 'Para salvar o projeto é necessário preencher o valor do serviço.',
        validationFn: () => {
          if (servicoObrigatorio && !valor_servico) return true;
          return false;
        }
      },
      {
        tooltip: 'Para finalizar o projeto é necessário inserir o valor mínimo do serviço',
        validationFn: () => {
          if (servicoObrigatorio && (valor_servico || 0) > 0 && !validacaoValorServicoMinimo(valor_servico || 0, valor_minimo_servico, permissoes)) {
            return true;
          }
          return false;
        }
      },
      {
        tooltip: `Para finalizar o projeto é necessário inserir a justificativa do valor de serviço`,
        validationFn: () => {
          if (exibirJustificativaValorServico && !(justificativa_valor_servico || "")) return true;
          return false;
        }
      },
      {
        tooltip: 'Não foi possível calcular os valores do projeto, preencha todos os campos obrigatórios para prosseguir.',
        validationFn: () => {
          return !resultado_calculos
        }
      },
      {
        tooltip: 'Aguarde o calculo finalizar para prosseguir.',
        validationFn: () => {
          return calculando
        }
      },
      {
        tooltip: 'Selecione um módulo para prosseguir.',
        validationFn: () => {
          return !modulo_selecionado
        }
      },
      {
        tooltip: `Cabo: ${MENSAGEM_QUANTIDADE_CABOS_INVALIDA}`,
        validationFn: () => {
          const cabos = acessorios.filter(item => item.categoria_componentes_id === ID_CABO);
          if (cabos.some(cabo => checkError(cabo.categoria_componentes_id, Number(cabo.quantidade)))) {
            return true
          }
          return false;
        }
      },
    ]

    const firstError = validations.find(validation =>  validation.validationFn() )
    
    return { status: !!firstError, tooltip: firstError?.tooltip || '' }
  },[calculando, exibirJustificativaValorServico, fileiras, justificativa_valor_servico, modulo_selecionado, permissoes, projetosOffGridStoreValidationState.fileiras.helper, projetosOffGridStoreValidationState.fileiras.status, resultado_calculos, servicoObrigatorio, valor_minimo_servico, valor_servico, acessorios, checkError])

  const itensSolucao = useMemo(() => {
    const categorias = categoriasComponentes?.data || [];
    const itens = [...solucao_calculada.inversores, ...solucao_calculada.controladores, ...solucao_calculada.baterias]
    return itens?.map(item => {
        const categoria = categorias?.find((i: CategoriaComponente) => i.id === item?.categoria_componentes_id);
        return {
          ...item,
          nome_categoria: categoria?.nome || "",
          grupo_categoria: categoria?.grupo || "",
          ordem_listagem: categoria?.ordem_listagem || item?.categoria_componentes_id,
        }
      })?.sort((a, b) => {
        const pesoGrupoA = ORDEM_GRUPO_CATEGORIAS[a.grupo_categoria as TGrupoCategoria] || a?.categoria_componentes_id;
        const pesoGrupoB = ORDEM_GRUPO_CATEGORIAS[b.grupo_categoria as TGrupoCategoria] || b?.categoria_componentes_id;
  
        if (pesoGrupoA !== pesoGrupoB) {
          return pesoGrupoA - pesoGrupoB;
        }
  
        return a.ordem_listagem - b.ordem_listagem;
      })
  }, [solucao_calculada.baterias, solucao_calculada.controladores, solucao_calculada.inversores, categoriasComponentes])

  const itensEstruturas = useMemo(() => {
    const categorias = categoriasComponentes?.data || [];
    const itens = estruturas_calculadas || [];
    return itens?.map(item => {
        const categoria = categorias?.find((i: CategoriaComponente) => i.id === item?.categoria_componentes_id);
        return {
          ...item,
          ordem_listagem: categoria?.ordem_listagem || item?.categoria_componentes_id,
        }
      })?.sort((a, b) => a.ordem_listagem - b.ordem_listagem)
  }, [estruturas_calculadas, categoriasComponentes])

  const itensAcessorios = useMemo(() => {
    const categorias = categoriasComponentes?.data || [];
    const itens = acessorios || [];
    return itens?.map(item => {
        const categoria = categorias?.find((i: CategoriaComponente) => i.id === item?.categoria_componentes_id);
        return {
          ...item,
          ordem_listagem: categoria?.ordem_listagem || item?.categoria_componentes_id,
        }
      })?.sort((a, b) => a.ordem_listagem - b.ordem_listagem)
  }, [acessorios, categoriasComponentes])

  const notSelectedModulos = useMemo(() => {
    return (modulos || []).filter(item => item.componente_id !== modulo_selecionado?.componente_id)
  }, [modulo_selecionado?.componente_id, modulos])

  if (isMobile){
    return (<>
      <Layout
        onClickBack={onClickBack}
        onClickNext={onClickNext}
        nextButtonIsDisabled={nextButtonDisabledStatus.status}
        nextButtonDisabledTooltip={nextButtonDisabledStatus.tooltip}
        title="Solução"
        nextButtonLabel="Finalizar projeto">
          <SolucaoMobile handleOpenModalEstruturas={()=>setModalEditarEstruturasOpen(true)} handleChangeModulo={(moduloId: number)=>onChangeModulo(moduloId)}/>
          {modalEditarEstruturasOpen && <ModalEditarEstruturas open={modalEditarEstruturasOpen} onClose={() => setModalEditarEstruturasOpen(false)} />}
          <ServicoInformationModal formState={{ valor_servico, valor_servico_pis_cofins } as any} />
      </Layout>
    </>)
  }
  return (
    <Layout
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      nextButtonIsDisabled={nextButtonDisabledStatus.status}
      nextButtonDisabledTooltip={nextButtonDisabledStatus.tooltip}
      title="Solução"
      nextButtonLabel="Finalizar projeto"
    >
      <Box p={2}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              {temPermissaoCodigoComponente && <TableCell style={{ width: "126px" }} align='left'><strong>Código</strong></TableCell>}
              <TableCell align='left'><strong>Produtos</strong></TableCell>
              <TableCell style={{ width: "220px" }} align='center'><strong>Quantidade</strong></TableCell>
              <TableCell style={{ width: "200px" }} align='center'><strong>Dados Técnicos</strong></TableCell>
              <TableCell style={{ width: "200px" }}  align='center' />
            </TableRow>
          </TableHead>
        </Table>

        <Collapse key={'key'} className={classes.collapseContainer} in={collapseOpened} collapsedSize={"120px"} style={{ marginBottom: 0 }}>
          <TableContainer>
            <Table aria-label="listagem de modulos disponíveis">
              <TableRow style={{ cursor: 'pointer' }} onClick={() => setCollapseOpened(old => !old)}>
                {temPermissaoCodigoComponente && <CodigoCell>
                  <span>{modulo_selecionado?.componente_id || ''}</span>
                </CodigoCell>}
                <ProdutoCell>
                  <Box display='flex'>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={modulo_selecionado?.componente_id || ''}
                      name="radio-buttons-group"
                      onChange={(e: any) => {}}
                    >
                      <FormControlLabel disabled value={modulo_selecionado?.componente_id} control={<Radio style={{color: "green"}}/>} label="" />
                    </RadioGroup>
                    <Box textAlign={'left'}>
                      <Typography variant='body1' color='textPrimary'>
                        <strong>{modulo_selecionado?.nome}</strong>
                      </Typography>
                      <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}><strong>Informações:</strong></span> {modulo_selecionado?.descricao}
                      </Typography>
                    </Box>
                  </Box>
                </ProdutoCell>
                <QuantidadeCell>
                  <Box width="180px">
                    <InputQuantidade value={modulo_selecionado?.quantidade || 0} highlightField={false} onChange={() => {}} disabled={true} />
                  </Box>
                </QuantidadeCell>
                  <DadosTecnicosCell componente={{ componente_id: modulo_selecionado?.componente_id || null }} />
                <EmptyCell>
                  {notSelectedModulos.length > 0 && (
                    <>
                      {collapseOpened ? <KeyboardArrowUp /> : <KeyboardArrowDown /> }
                    </>
                  )}
                </EmptyCell>
              </TableRow>
              <TableBody>
                {notSelectedModulos.map(modulo => (
                  <TableRow key={'id'}>
                      {temPermissaoCodigoComponente && (
                        <CodigoCell>
                          <span>{modulo?.componente_id || ''}</span>
                        </CodigoCell>
                      )}
                      <ProdutoCell>
                      <Box display='flex' flexDirection={'row'}>
                        <RadioGroup
                          row
                          aria-labelledby="demo-radio-buttons-group-label"
                          value={null}
                          name="radio-buttons-group"
                          onChange={(e: any) => {
                            onChangeModulo(Number(e.target.value))
                          }}
                      >
                          <FormControlLabel value={modulo.componente_id} control={<Radio style={{color: "green"}}/>} label="" />
                        </RadioGroup>
                        <Box textAlign={'left'}>
                          <Typography variant='body1' color='textPrimary'>
                            <strong>{modulo.nome}</strong>
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            <span className={classes.warningText}><strong>Informações:</strong></span> {modulo.descricao}
                          </Typography>
                        </Box>
                      </Box>
                    </ProdutoCell>
                    <QuantidadeCell>
                      <Box width="180px"/>
                    </QuantidadeCell>
                      <DadosTecnicosCell componente={{ componente_id: modulo?.componente_id || null }} />
                    <EmptyCell />
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>

        {itensSolucao.length > 0 && (
          <Table aria-label="listagem da solução calculada">
            <TableBody>
              {itensSolucao.map(item => (
                <TableRow>
                  {temPermissaoCodigoComponente && (
                    <CodigoCell>
                      <span>{item?.componente_id || ''}</span>
                    </CodigoCell>
                  )}
                  <ProdutoCell>
                    <Box display='flex' flexDirection={'row'}>
                      <Box textAlign={'left'}>
                        <Typography variant='body1' color='textPrimary'>
                          <strong>{item.nome}</strong>
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                          <span className={classes.warningText}><strong>Informações:</strong></span> {item?.descricao}
                        </Typography>
                      </Box>
                    </Box>
                  </ProdutoCell>
                  <QuantidadeCell>
                    <Box width="180px" >
                      <InputQuantidade value={item.quantidade} highlightField={false} disabled={true} onChange={(v: number) => {}} />
                    </Box>
                  </QuantidadeCell>
                    <DadosTecnicosCell componente={{ componente_id: item?.componente_id || null }} />
                  <EmptyCell />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        {itensEstruturas?.length > 0 && (
          <Table aria-label="listagem de estruturas calculadas">
            <TableBody>
              {itensEstruturas.map(item => (
                <TableRow key={'id'}>
                  {temPermissaoCodigoComponente && (
                    <CodigoCell>
                      <span>{item?.componente_id || ''}</span>
                    </CodigoCell>
                  )}
                  <ProdutoCell>
                    <Box display='flex' flexDirection={'row'}>
                      <Box textAlign={'left'}>
                        <Typography variant='body1' color='textPrimary'>
                          <strong>{item.nome}</strong>
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                          <span className={classes.warningText}><strong>Informações:</strong></span> {item?.descricao}
                        </Typography>
                      </Box>
                    </Box>
                  </ProdutoCell>
                  <QuantidadeCell>
                    <Box width="180px">
                      <InputQuantidade value={item.quantidade} highlightField={false} disabled={false} onChange={(v: number) => onChangeQuantidade(item.componente_id, v, "estruturas")} />
                    </Box>
                  </QuantidadeCell>
                    <DadosTecnicosCell componente={{ componente_id: item?.componente_id || null }} />
                  <EmptyCell />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        {itensAcessorios?.length > 0 && (
          <Table aria-label="listagem de modulos disponíveis">
            <TableBody>
              {itensAcessorios.map(item => (
                <TableRow key={'id'}>
                  {temPermissaoCodigoComponente && (
                    <CodigoCell>
                      <span>{item?.componente_id || ''}</span>
                    </CodigoCell>
                  )}
                  <ProdutoCell>
                    <Box display='flex' flexDirection={'row'}>
                      <Box textAlign={'left'}>
                        <Typography variant='body1' color='textPrimary'>
                          <strong>{item.nome}</strong>
                        </Typography>
                        <Typography variant='body2' color='textSecondary'>
                          <span className={classes.warningText}><strong>Informações:</strong></span> {item?.descricao}
                        </Typography>
                      </Box>
                    </Box>
                  </ProdutoCell>
                  <QuantidadeCell>
                    <Box width="180px">
                      <InputQuantidade multiple={item.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1} value={item.quantidade} highlightField={false} disabled={false} onChange={(v: number) => onChangeQuantidade(item.componente_id, v, "acessorios")} hasError={checkError(item.categoria_componentes_id, item.quantidade)}/>
                      {item.categoria_componentes_id === ID_CABO && checkError(item.categoria_componentes_id, item.quantidade) && (
                        <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
                      )}
                    </Box>
                  </QuantidadeCell>
                    <DadosTecnicosCell componente={{ componente_id: item?.componente_id || null }} />
                  <EmptyCell />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        <Box mt={4} className="row" display="flex" justifyContent={"flex-end"}>
          <Button variant="contained" onClick={() => setModalEditarEstruturasOpen(true)} className={classes.restoreButton}>Editar Estruturas</Button>
        </Box>
      </Box>

      <Box className="row X12" style={{ padding: '0 0 16px 16px', }} display="flex" justifyContent={"space-between"}>
        <div className="X6">
          <TipoPropostaInput />
        </div>
        <div className="X6">
          <ValorServicoInput servicoObrigatorio={servicoObrigatorio} />
        </div>
      </Box>
      
      {exibirJustificativaValorServico && (
        <Box className="row X12" display="flex" paddingLeft={"20px"} justifyContent={"space-between"}>
          <JustificativaValorServico
            formState={{ justificativa_valor_servico: justificativa_valor_servico || "" } as any }
            setFormState={(data) => changeStoreValue({ justificativa_valor_servico: data.justificativa_valor_servico })} />
        </Box>
      )}

      <ResumoProjeto />

      <ServicoInformationModal formState={{ valor_servico, valor_servico_pis_cofins } as any} />

      {modalEditarEstruturasOpen && <ModalEditarEstruturas open={modalEditarEstruturasOpen} onClose={() => setModalEditarEstruturasOpen(false)} />}
    </Layout>
  )
}
